import { padding } from 'polished'

const __showKeyFrame = isDesktop => ({
	'0%': { opacity: 0, bottom: isDesktop ? '20%' : -10 },
	'100%': { opacity: 1, bottom: isDesktop ? '25%' : 0 },
})

const __hideKeyFrame = isDesktop => ({
	'0%': { opacity: 1, bottom: isDesktop ? '25%' : 0 },
	'100%': {
		opacity: 0,
		bottom: isDesktop ? '20%' : -10,
	},
})

export const __ToastBody = props => ({
	width: props.isDesktop ? '350px' : 'calc(100vw - 32px)',
	marginLeft: '16px',
	marginBottom: props.persists ? '8px' : '80px',
	marginTop: props.persists ? '8px' : '0px',
	minheight: '48px',
	borderRadius: '4px',
	display: 'flex',
	alignItems: 'center',
	position: props.fixed ? 'fixed' : 'initial',
	bottom: 0,
	zIndex: props.theme.zIndex.level5,
	...padding(16),
	color: props.theme.colors.lightGrey4,
	extend: [
		{
			condition: props.type === 'info',
			style: {
				backgroundColor: props.theme.colors.bmsDarkBlue,
			},
		},
		{
			condition: props.type === 'error',
			style: {
				backgroundColor: props.theme.colors.errorRed,
			},
		},
		{
			condition: props.type === 'success',
			style: {
				backgroundColor: props.theme.colors.successGreen,
			},
		},
		{
			condition: props.type === 'update',
			style: {
				backgroundColor: props.theme.colors.white,
				color: props.theme.colors.darkGrey4,
				fontWeight: 'normal',
			},
		},
		{
			condition: !props.fixed && !props.show,
			style: {
				display: 'none',
			},
		},
		{
			condition: props.fixed && props.show,
			style: {
				animationName: __showKeyFrame(props.isDesktop),
				animationDuration: '300ms',
				animationTimingFunction: 'ease-in',
			},
		},
		{
			condition: props.fixed && !props.show,
			style: {
				animationName: __hideKeyFrame(props.isDesktop),
				animationDuration: '300ms',
				animationTimingFunction: 'ease-out',
				opacity: 0,
				zIndex: -5,
			},
		},
		{
			condition: props.fixed && props.isDesktop,
			style: {
				left: '50%',
				bottom: '25%',
				width: '25%',
				overflow: 'hidden',
				transform: 'translate(-50%, 0)',
			},
		},
	],
})

export const __SvgSize = ({ alignIcon }) => ({
	width: 20,
	height: 20,
	marginBottom: 3,
	marginRight: 10,
	extend: [
		{
			condition: alignIcon === 'RIGHT',
			style: {
				margin: '0 0 0 auto',
			},
		},
	],
})

export const __TextSize = props => ({
	wordWrap: 'break-word',
	...props.theme.mediumBaseFont,
	fontSize: props.theme.fontSize.s,
	lineHeight: '16px',
})
